import { GetApp } from "../../App"
import { DetailsToggle } from "../../Components/DetailsToggle"
import { TripHeaderViewProps } from "./Params"

// The TripView header: the details toggle, the trip title and the start/end summary. The
// start/end locations are derived by the root from trip.calculated and threaded in. Keeps
// the original TripView-header / -title / -summary / -divider class names.
export function TripHeaderView({ trip, details, onDetailsChange, startLocation, endLocation }: TripHeaderViewProps) {
  const app = GetApp();
  const t = app.getT("TripView");

  return (
    <div className={"TripView-header" + (details ? " details" : "")} data-trip-id={trip.id}>
      <DetailsToggle className={"TripView-details-toggle"} onChange={onDetailsChange} />
      <div className="TripView-title">
        »{trip.title || t("untitled_trip")}«
      </div>
      <div className="TripView-summary">
        {app.format("date", trip.startedAt)}
        <strong>
          <span className="TripView-divider">•</span>
          {startLocation}
        </strong>
        <span className="TripView-divider">…</span>
        {app.format("date", trip.completedAt)}
        <strong>
          <span className="TripView-divider">•</span>
          {endLocation}
        </strong>
        {/* <span className="debug-data"> {["tripId:", trip.id, "cruiseId:", trip.cruiseId].join(" ")}</span> */}
      </div>
    </div>
  );
}
